<div class="sin-value-container">
  <div class="sin-value">{{ sin | maskSinNumber : (showFullSin$ | async)! : true }}</div>
  <div>
    <button class="eye" (click)="toggleShowFullSin($event)">
      <img [src]="iconSrc$ | async" alt="eyeball icon" i18n-alt [style.width.rem]="1.25" [style.height.rem]="1.25" />
    </button>
  </div>
</div>
